(function() {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
  .factory('OrgaoService', OrgaoService);

  function OrgaoService($http, ngsalConfig) {
    var service = {
      consultarOrgao: consultarOrgao
    };

    return service;

    function consultarOrgao(query, timeoutPromise) {

      var promise = $http.post(`/mgp-corregedoria/api/${ngsalConfig.apiVersion}/orgao`, {
        query: query
      }, {
        timeoutPromise
      })
      .then(function(response) {
        return response.data;
      });

      return promise;

    }
  }

})();
